import log from 'salvo-lite/log'
import axios from 'axios'

class FilterAndSort {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-filter-and-sort'))
        this._productCardSelector = this._options.productCardSelector
        this._productsContainer = document.querySelector(this._options.productsContainer)

        this._filterTriggers = elem.querySelectorAll('[data-filter-type]')
        this._dropdownBtns = document.querySelectorAll('.filter-dropdown__btn')

        this._activeTags = []
        this._activeTagsWrapper = document.querySelector('.filters__options')
        this._activeTagsContainer = document.querySelector('.active-tags')
        this._mobileActiveTagsContainer = document.querySelector('.active-tags--mobile')

        this._sortBy = document.querySelector('[data-sort-by]')
        this._sortValueText = this._sortBy.querySelector('[data-sort-value]')
        this._currentSort = this._sortBy.getAttribute('data-sort-value')
        this._currentMobileSort = this._sortBy.getAttribute('data-sort-value-mobile')
        this._sortBtns = this._sortBy.querySelectorAll('[data-sort-select]')
        this._mobileSortBtns = document.querySelectorAll('[data-sort-select-mobile]')

        this._products = [...document.querySelectorAll(this._productCardSelector)]
        this._filteredProducts = []

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.initFilterTriggers()

        this.initPagination()

        this.initDropdownBtnListener()

        this.initSortBtnListeners()
        this.initMobileSort()

        document.querySelector('.filters-btns--mobile .clear-filters').addEventListener('click', () => {
            this.clearAll()
        })

        // If previous sort selection has been stored in localStorage
        if (localStorage && localStorage.getItem('Zo-onSortBy')) {
            const sortOption = localStorage.getItem('Zo-onSortBy')
            // Get the corresponding text and update the sort dropdown
            const sortButton = document.querySelector(`[data-sort-select="${sortOption}"]`)
            if (sortButton) {
                const sortText = sortButton.innerText
                this._sortValueText.innerHTML = sortText
                // Sort products
                this.sortProducts(localStorage.getItem('Zo-onSortBy'))
            }
        }
    }

    initFilterTriggers () {
        this._filterTriggers.forEach(filter => {
            filter.addEventListener('click', event => {
                if (event.target.closest('.filter-dropdown__btn') || event.target.closest('.price-span')) {
                    return
                }

                const linkedDropdown = filter.querySelector('[data-filter-options]')

                let currentNode = false

                if (filter.classList.contains('open')) {
                    currentNode = true
                }

                document.querySelectorAll('.filter-dropdown').forEach(dropdown => {
                    dropdown.classList.remove('open')
                })

                document.querySelectorAll('.filter-dropdown__btns-container').forEach(container => {
                    container.classList.remove('open')
                })

                if (currentNode) {
                    if (window.innerWidth < 900) {
                        filter.classList.remove('open')
                    } else {
                        filter.parentNode.classList.remove('open')
                    }
                } else {
                    filter.parentNode.classList.add('open')
                    filter.classList.add('open')
                    linkedDropdown.classList.add('open')
                }
            })
        })
    }

    initPagination () {
        this.paginateBy(8)

        document.querySelector('#paginate-btn').addEventListener('click', () => {
            this.paginateBy(8)
        })
    }

    paginateBy (val) {
        this._paginateNext = [...document.querySelectorAll('.product-item.visually-hidden')]

        let _val = val
        if (this._paginateNext.length < val) {
            _val = this._paginateNext.length
        }

        for (let i = 0; i < _val; i++) {
            this._paginateNext[i].classList.remove('visually-hidden')
        }

        if (this._paginateNext.length < 8) {
            document.querySelector('#paginate-btn').classList.add('visually-hidden')
        } else {
            document.querySelector('#paginate-btn').classList.remove('visually-hidden')
        }
    }

    initDropdownBtnListener () {
        this._dropdownBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const type = btn.getAttribute('data-type')
                const option = btn.getAttribute('data-option')

                if (type === 'price') {
                    // Check selected price filters
                    const selectedPriceFilters = this._activeTags.filter((filter) => {
                        return filter[0] === 'price'
                    })

                    // If price filter already exists, remove it
                    if (selectedPriceFilters.length) {
                        this.removeActiveTag(selectedPriceFilters[0], true)
                    }
                }

                if (!btn.classList.contains('open')) {
                    btn.classList.add('open')
                    this.filterInit(type, option)
                }
            })
        })
    }

    filterInit (type, filterOption) {
        const arrayToUse = this._activeTags.length > 0 ? this._filteredProducts : this._products

        const matchingArrays = this._activeTags.find((array) => {
            return array === arrayToUse
        })

        if (matchingArrays) {
            return
        }

        this._activeTags.push([type, filterOption])

        this._productsContainer.innerHTML = ''

        if (type === 'size' || type === 'colour' || type === 'color') {
            this.optionFilter(type, filterOption, arrayToUse)
        } else if (type === 'price') {
            this.priceFilter(filterOption, arrayToUse)
        } else if (type === 'type') {
            // There was originally a filter for product type
            // which has been left below, but we now filter by tag
            // See this.typeFilter()
            this.tagFilter(filterOption, arrayToUse)
        } else {
            this.tagFilter(filterOption, arrayToUse)
        }

        this.paginateBy(8)
        this._activeTagsContainer.classList.add('open')
        this.buildActiveTags()
    }

    optionFilter (type, option, array) {
        if (type === 'colour') {
            type = 'color'
        }

        this._filteredProducts = array.filter(product => {
            product.classList.add('visually-hidden')
            const productJSON = JSON.parse(product.getAttribute('data-options'))

            if (productJSON[type] && productJSON[type].includes(option)) {
                this._productsContainer.appendChild(product)
                return product
            }
        })
    }

    priceFilter (option, array) {
        option = JSON.parse(option)

        this._filteredProducts = array.filter(product => {
            product.classList.add('visually-hidden')
            const price = parseInt(product.getAttribute('data-price'))

            const lowCompare = option.lowCompare
            let highCompare = option.highCompare

            if ((price > lowCompare && price < highCompare)) {
                this._productsContainer.appendChild(product)
                return product
            }
        })
    }

    typeFilter (option, array) {
        this._filteredProducts = array.filter(product => {
            product.classList.add('visually-hidden')
            const type = product.getAttribute('data-type')

            if (type === option) {
                this._productsContainer.appendChild(product)
                return product
            }
        })
    }

    tagFilter (option, array) {
        this._filteredProducts = array.filter(product => {
            product.classList.add('visually-hidden')
            const tags = JSON.parse(product.getAttribute('data-tags'))

            const tagMatch = tags.find((tag) => {
                return tag === option
            })

            if (tagMatch) {
                this._productsContainer.appendChild(product)
                return product
            }
        })
    }

    buildActiveTags () {
        const activeTags = this._activeTags
        document.querySelector('#filter-count').innerHTML = `(${activeTags.length})`

        this._activeTagsContainer.innerHTML = ''
        this._mobileActiveTagsContainer.innerHTML = ''

        const btnContainer = document.createElement('div')
        btnContainer.classList.add('flex')

        const mobileBtnContainer = document.createElement('div')
        mobileBtnContainer.classList.add('flex', 'f-wrap')

        for (let i = 0; i < activeTags.length; i++) {
            const type = activeTags[i][0]
            const value = activeTags[i][1]

            let _innerHTML
            if (type === 'colour' || type === 'color') {
                _innerHTML = `
                    <div class="flex f-vertical-center">
                        <div class="swatch--color" style="background-color:${value};"></div>
                        ${value.split('').map(char => char.toUpperCase()).join('')}
                        <span class="close--btn">&times;</span>
                    </div>
                `
            } else if (type === 'price') {
                const lowCompare = JSON.parse(value).lowCompare
                const highCompare = JSON.parse(value).highCompare

                if (highCompare === 1e99) {
                    _innerHTML = `${lowCompare} <span class="close--btn" aria-label="Close">&times;</span>`
                } else if (lowCompare === 0) {
                    _innerHTML = `${highCompare} <span class="close--btn" aria-label="Close">&times;</span>`
                } else {
                    _innerHTML = `${lowCompare}-${highCompare} <span class="close--btn" aria-label="Close">&times;</span>`
                }
            } else {
                _innerHTML = `
                    ${value.split('').map(char => char.toUpperCase()).join('')} <span class="close--btn">&times;</span>
                `
            }

            const button = document.createElement('button')
            button.setAttribute('class', 'active-tags__btn flex f-vertical-center')
            button.innerHTML = _innerHTML

            const mobileButton = document.createElement('button')
            mobileButton.setAttribute('class', 'active-tags__btn flex f-vertical-center m-b-xxs')
            mobileButton.innerHTML = _innerHTML

            button.addEventListener('click', () => {
                this.removeActiveTag(activeTags[i])
            })

            mobileButton.addEventListener('click', () => {
                this.removeActiveTag(activeTags[i])
            })

            btnContainer.appendChild(button)
            mobileBtnContainer.appendChild(mobileButton)
        }

        this._activeTagsContainer.appendChild(btnContainer)
        this._mobileActiveTagsContainer.appendChild(mobileBtnContainer)

        const clearAll = document.createElement('button')
        clearAll.innerHTML = 'Clear All Filters'
        clearAll.classList.add('above-mobile')

        clearAll.addEventListener('click', () => {
            this.clearAll()
        })

        this._activeTagsContainer.appendChild(clearAll)
    }

    removeActiveTag (tag, isReplacing = false) {
        let activeTags = this._activeTags

        this._dropdownBtns.forEach(btn => {
            const type = btn.getAttribute('data-type')
            const option = btn.getAttribute('data-option')
            if (type === tag[0] && option === tag[1]) {
                btn.classList.remove('open')
            }
        })

        activeTags = activeTags.filter((tagArray) => {
            return tagArray !== tag
        })

        this._activeTags = activeTags

        if (activeTags.length === 0 && !isReplacing) {
            this.clearAll()
            return
        } else {
            this._filteredProducts = this._products

            this._filteredProducts.forEach(product => product.classList.add('visually-hidden'))

            for (let i = 0; i < activeTags.length; i++) {
                let filterType = activeTags[i][0]
                const filterOption = activeTags[i][1]

                if (filterType === 'size' || filterType === 'colour' || filterType === 'color') {
                    this.optionFilter(filterType, filterOption, this._filteredProducts)
                } else if (filterType === 'price') {
                    this.priceFilter(filterOption, this._filteredProducts)
                } else if (filterType === 'type') {
                    // There was originally a filter for product type
                    // which has been left in place, but we now filter by tag
                    // See this.typeFilter()
                    this.tagFilter(filterOption, this._filteredProducts)
                } else {
                    this.tagFilter(filterOption, this._filteredProducts)
                }
            }
        }

        this._productsContainer.innerHTML = ''
        this._filteredProducts.forEach(product => {
            this._productsContainer.appendChild(product)
        })

        this.paginateBy(8)
        this.buildActiveTags()
    }

    clearAll () {
        this._activeTags = []
        document.querySelector('#filter-count').innerHTML = ''

        this._productsContainer.innerHTML = ''
        this._activeTagsContainer.innerHTML = ''
        this._mobileActiveTagsContainer.innerHTML = ''

        const removeAll = [
            this._activeTagsWrapper,
            this._activeTagsContainer,
            this._mobileActiveTagsContainer,
            document.querySelector('.filters'),
            ...document.querySelectorAll('.filter-dropdown'),
            ...document.querySelectorAll('.filter-dropdown__btns-container'),
            ...document.querySelectorAll('.filter-dropdown__btn')
        ]

        removeAll.forEach(item => {
            item.classList.remove('open')
        })

        this._products.forEach(product => {
            product.classList.add('visually-hidden')
            this._productsContainer.appendChild(product)
        })

        this.paginateBy(8)
    }

    initSortBtnListeners () {
        this._sortBtns.forEach(btn => btn.addEventListener('click', () => {
            this._sortValueText.innerHTML = btn.innerHTML
            this._currentSort = btn.getAttribute('data-sort-select')

            this.sortProducts(this._currentSort)

            if (localStorage) {
                localStorage.setItem('Zo-onSortBy', this._currentSort)
            }
        }))
    }

    initMobileSort () {
        this._mobileSortBtns.forEach(btn => btn.addEventListener('click', () => {
            this._currentMobileSort = btn.getAttribute('data-sort-select-mobile')
            document.querySelector('.sort-by__dropdown--mobile').classList.remove('active')

            this.sortProducts(this._currentMobileSort)

            if (localStorage) {
                localStorage.setItem('Zo-onSortBy', this._currentMobileSort)
            }
        }))
    }

    async sortProducts (sort) {
        if (window.location.href.includes('search')) {
            if (sort === 'price-descending') {
                this._products = this._products.sort((a, b) => {
                    const aPrice = parseInt(a.getAttribute('data-price'))
                    const bPrice = parseInt(b.getAttribute('data-price'))
                    if (aPrice > bPrice) {
                        return -1
                    }
                    if (aPrice < bPrice) {
                        return 1
                    }
                    return 0
                })
            }

            if (sort === 'price-ascending') {
                this._products = this._products.sort((a, b) => {
                    const aPrice = parseInt(a.getAttribute('data-price'))
                    const bPrice = parseInt(b.getAttribute('data-price'))
                    if (aPrice < bPrice) {
                        return -1
                    }
                    if (aPrice > bPrice) {
                        return 1
                    }
                    return 0
                })

                if (this._activeTags.length > 0) {
                    this.removeActiveTag('rebuild')
                } else {
                    this._products.forEach(product => {
                        product.classList.add('visually-hidden')
                        this._productsContainer.appendChild(product)
                    })

                    this.paginateBy(8)
                }
            }

            if (sort === 'manual') {
                const url = window.location.origin + window.location.pathname + '?sort_by=' + sort

                try {
                    const res = await axios.get(url)

                    const div = document.createElement('div')
                    div.innerHTML = res.data

                    const items = [...div.querySelectorAll('.product-item')].map(el => {
                        return el.getAttribute('data-product')
                    })

                    this._products = this._products.sort((a, b) => {
                        const aHandle = a.getAttribute('data-product')
                        const bHandle = b.getAttribute('data-product')

                        return items.indexOf(aHandle) - items.indexOf(bHandle)
                    })

                    this._productsContainer.innerHTML = ''

                    if (this._activeTags.length > 0) {
                        this.removeActiveTag('rebuild')
                    } else {
                        this._products.forEach(product => {
                            product.classList.add('visually-hidden')
                            this._productsContainer.appendChild(product)
                        })

                        this.paginateBy(8)
                    }
                } catch (error) {
                    console.log(error)
                }
            }

            this._products.forEach(product => {
                product.classList.add('visually-hidden')
                this._productsContainer.appendChild(product)
            })
            this.paginateBy(8)
            return
        }

        const url = window.location.origin + window.location.pathname + '?sort_by=' + sort

        try {
            const res = await axios.get(url)

            const div = document.createElement('div')
            div.innerHTML = res.data

            const items = [...div.querySelectorAll('.product-item')].map(el => {
                return el.getAttribute('data-product')
            })

            this._products = this._products.sort((a, b) => {
                const aHandle = a.getAttribute('data-product')
                const bHandle = b.getAttribute('data-product')

                return items.indexOf(aHandle) - items.indexOf(bHandle)
            })

            this._productsContainer.innerHTML = ''

            if (this._activeTags.length > 0) {
                this.removeActiveTag('rebuild')
            } else {
                this._products.forEach(product => {
                    product.classList.add('visually-hidden')
                    this._productsContainer.appendChild(product)
                })

                this.paginateBy(8)
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export default FilterAndSort



// WEBPACK FOOTER //
// ./src/resources/scripts/components/FilterAndSort.js